import styled from 'styled-components';
import { Link } from '@curi/react-dom';

export const FloatingLink = styled(Link)`
  position: absolute;
  top: 0;
  margin: 2rem;
  right: 0;
`;

export const Container = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 100%;
  flex-flow: column;
  padding: 5rem;
`;

export const InputContainer = styled.form`
  display: flex;
  justify-content: space-around;
  flex-flow: column;
  align-items: center;
  padding: 2rem;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  position: relative;
`;

export const Button = styled.button`
  margin: 10px 8px;
  display: inline-block;
  min-height: 36px;
  background-color: #5AC8FA;
  color: white;
  width: 100%;
  text-align: center;
  font-size: 1.4rem;
  line-height: 2rem;
  cursor: pointer;
  border-radius: 4px;
  border: none;
  &:hover {
    background-color: #71d5f5;
    color: #f7f7f7;
  }
`;



// WEBPACK FOOTER //
// ./src/auth/components.js